// Pure functions for TextInput number/mask formatting
import { isIOS, isMobileOnly } from 'react-device-detect';
import type { TextInputProps } from './types';

/**
 * Builds the extra number-format input props that bring up a numeric keyboard on mobile.
 * Returns no options unless isKeyboardNumberMobile is set; on iOS it allows dot and comma
 * separators and sets a decimal inputMode when decimalSeparator is set, otherwise a digits pattern.
 *
 * @param props - The isKeyboardNumberMobile and decimalSeparator text input props.
 * @returns The input options to spread onto the number field, possibly empty.
 */
export const generateOptionNumberInput = ({
  isKeyboardNumberMobile,
  decimalSeparator,
}: Pick<TextInputProps, 'isKeyboardNumberMobile' | 'decimalSeparator'>) => {
  const option: any = {};
  if (!isKeyboardNumberMobile) {
    return option;
  }

  // *: https://github.com/s-yadav/react-number-format/issues/189
  // *: Allow iOS keyboard to display decimal seperator
  if (isIOS) {
    option.allowedDecimalSeparators = ['.', ','];
    if (decimalSeparator) {
      option.inputMode = 'decimal';
    } else {
      option.pattern = '[0-9]*';
    }
  }
  return option;
};

/**
 * Builds the extra masked-input props that bring up a numeric keyboard on phones.
 * Returns no options unless isKeyboardNumberMobile is set, and on mobile-only devices sets a
 * numeric inputMode with a digits pattern.
 *
 * @param props - The isKeyboardNumberMobile text input prop.
 * @returns The input options to spread onto the masked field, possibly empty.
 */
export const generateOptionInputMask = ({
  isKeyboardNumberMobile,
}: Pick<TextInputProps, 'isKeyboardNumberMobile'>) => {
  const option: any = {};
  if (!isKeyboardNumberMobile) {
    return option;
  }
  // Allow Mobile keyboard show number keyboard
  if (isMobileOnly) {
    option.inputMode = 'numeric';
    option.pattern = '[0-9]*';
  }
  return option;
};
